import i18n from './i18n';

export const isEnglishLocale = () => (i18n.language || '').startsWith('en');

export const appDateLocale = () => (isEnglishLocale() ? 'en-US' : 'ru-RU');

const CONTENT_TRANSLATIONS = {
  'Все': 'All',
  'Попробовать': 'Try it',
  '🔥 Тренды в фото': '🔥 Photo trends',
  '🔥 Тренды в видео': '🔥 Video trends',
  'Наборы': 'Sets',
  'Пустая видеосекция': 'Empty video section',
  'Сломанная фото': 'Broken photo',
  'Горячие': 'Hot',
  'Красивая жизнь': 'Beautiful life',
  'Богатая жизнь': 'Luxury life',
  'Портреты': 'Portraits',
  'Праздники': 'Celebrations',
  'Спорт': 'Sports',
  'Один WIDE фото-тренд': 'Hot photo trends',

  'ОБЫЧНЫЙ': 'General',
  'РЕАЛИСТИЧНЫЙ': 'Realistic',
  'ДР': 'Birthday',
  'розовый birthday': 'Pink birthday',
  'СВАДЕБНАЯ МЕЧТА': 'Wedding dream',
  'Свадебная': 'Wedding',
  'Свадьба': 'Wedding',
  'свадьба': 'Wedding',
  'Тяжёлый люкс': 'Heavy luxury',
  'КОФЕ С МОЛОКОМ': 'Coffee with milk',
  'ПУПСИК': 'Baby doll',
  'СНЕГУРОЧКА': 'Snow Maiden',
  'Снегурочка': 'Snow Maiden',
  'ТОМИРИС': 'Tomiris',
  'Портрет с ребёнком': 'Portrait with child',

  'парень': 'Man',
  'парнень': 'Man',
  'девушка': 'Woman',
  'пара': 'Couple',
  'дочь': 'Daughter',
  'дочб': 'Daughter',
  'сын': 'Son',
  'жених': 'Groom',
  'невеста': 'Bride',
  'жених и невеста': 'Bride and groom',
  'пляж': 'Beach',
  'селфи': 'Selfie',
  'в машине': 'In the car',

  'Вирусный момент': 'Viral moment',
  'Горячий танец': 'Hot dance',
  'Студийный жар': 'Studio heat',
  'Летний зной': 'Summer heat',
  'Закат у бассейна': 'Sunset by the pool',
  'Шик на яхте': 'Yacht chic',
  'Роскошный закат': 'Luxury sunset',
  'Бутик-минимал': 'Boutique minimal',
  'Высокая мода': 'High fashion',
  'Подиум-драма': 'Runway drama',
  'Городской вайб': 'Urban vibe',
  'Неоновый город': 'Neon city',
  'Ночной клуб': 'Night club',
  'Динамичный портрет': 'Dynamic portrait',
  'Эмоция в фокусе': 'Emotion in focus',
  'Утренний свет': 'Morning light',
  'Морской бриз': 'Sea breeze',
  'Винтаж люкс': 'Vintage luxury',
};

const hasCyrillic = (value = '') => /[А-Яа-яЁё]/.test(String(value));

const humanizeId = (value = '') =>
  String(value)
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();

export function translateContentText(value, fallbackSeed = '') {
  if (!value) return '';
  const text = String(value).trim();
  if (!isEnglishLocale()) return text;
  if (CONTENT_TRANSLATIONS[text]) return CONTENT_TRANSLATIONS[text];
  if (!hasCyrillic(text)) return text;
  return fallbackSeed ? humanizeId(fallbackSeed) : text;
}

export function localizedField(item, baseField = 'name', { fallbackSeed } = {}) {
  if (!item) return '';

  const i18nField = `${baseField}I18n`;
  const localized = item[i18nField];
  if (localized && typeof localized === 'object' && !Array.isArray(localized)) {
    const values = localized.values && typeof localized.values === 'object'
      ? localized.values
      : {};
    const requested = i18n.resolvedLanguage || i18n.language || 'en';
    const exact = requested === 'pt-BR' ? 'pt-BR' : requested.split('-')[0];
    return (
      values[exact] ||
      values[localized.source] ||
      Object.values(values).find((value) => typeof value === 'string' && value.trim()) ||
      item[baseField] ||
      item[`${baseField}En`] ||
      item[`${baseField}_en`] ||
      ''
    );
  }

  if (isEnglishLocale()) {
    const pascal = `${baseField}En`;
    const snake = `${baseField}_en`;
    const resolvedFallbackSeed = fallbackSeed || item.slug || item.id || '';
    return (
      item[pascal] ||
      item[snake] ||
      translateContentText(item[baseField], resolvedFallbackSeed) ||
      humanizeId(resolvedFallbackSeed)
    );
  }

  return item[baseField] || item[`${baseField}Ru`] || item[`${baseField}_ru`] || '';
}
